import { serializable, alias, primitive, list, object } from 'serializr';
import { PaginationMeta } from '../userManager/userRecord.model';
import { BillingStatus, SubscriptionTier } from '../../enums/clientEnums';

// One row of GET /admin/clients. The listing carries no add-ons; those come from
// the per-client detail endpoint when a row is expanded.
export class ClientListItem {
  @serializable(alias('id', primitive()))
  id!: number;

  @serializable(alias('clientName', primitive()))
  clientName!: string;

  @serializable(alias('adminEmail', primitive()))
  adminEmail!: string;

  @serializable(alias('subscriptionType', primitive()))
  subscriptionType!: SubscriptionTier;

  @serializable(alias('subscriptionExpiresAt', primitive()))
  subscriptionExpiresAt!: string | null;

  @serializable(alias('storageUsedGB', primitive()))
  storageUsedGB!: number;

  @serializable(alias('storageTotalGB', primitive()))
  storageTotalGB!: number;

  @serializable(alias('cost', primitive()))
  cost!: number;

  @serializable(alias('status', primitive()))
  status!: BillingStatus;

  @serializable(alias('archived', primitive()))
  archived!: boolean;

  @serializable(alias('deletedAt', primitive()))
  deletedAt!: string | null;

  @serializable(alias('hasAddons', primitive()))
  hasAddons?: boolean;
}

export class PaymentOrganizationModel {
  @serializable(alias('paymentGroupId', primitive()))
  paymentGroupId!: number;

  @serializable(alias('paymentGroupName', primitive()))
  paymentGroupName!: string;

  @serializable(list(object(ClientListItem)))
  clients!: ClientListItem[];
}

export class ClientsListResponse {
  @serializable(list(object(PaymentOrganizationModel)))
  paymentOrganizations!: PaymentOrganizationModel[];

  // Same {total, limit, offset, hasMore} block the users list returns, so the
  // class is shared rather than restated.
  @serializable(object(PaginationMeta))
  pagination!: PaginationMeta;
}
